import React from 'react';
import { Text } from '@paypalcorp/pp-react';
import { StyleSheet, css } from 'aphrodite';
import { localsMessages } from '../utility/getTemplateData';

const messages = localsMessages('buttons/partner') || {};

const styles = StyleSheet.create({
  disclaimerWrapper: {
    maxWidth: 350,
    margin: 'auto',
    '.ppvx_accordion__row': { border: 'none' },
  },
  disclaimer: {
    margin: 'auto',
  },
});

export default function NotTaxDeductibleLegalText() {
  return (
    <div className={` ${css(styles.disclaimerWrapper)}`}>
      <Text
        size="sm"
        style={{
          color: '#687173',
          textAlign: 'center',
        }}
      >
        {messages.landing.mayNotBeTaxDeductible}
      </Text>
    </div>
  );
}
